export const ADVENTURE_LOG_FILTERS = [
  ['all', 'All'],
  ['important', 'Important'],
  ['travel', 'Travel'],
  ['market', 'Market'],
  ['world', 'World'],
];

export function normalizeAdventureEntries(gameState) {
  const entries = Array.isArray(gameState?.adventureLog?.entries) ? gameState.adventureLog.entries : [];
  return entries.map((entry, index) => ({
    id: String(entry.id || `log-${index}`),
    sequence: Number(entry.sequence || 0),
    title: entry.title || 'Street update',
    message: entry.message || '',
    category: String(entry.category || 'system').toLowerCase(),
    important: Boolean(entry.important),
    routine: Boolean(entry.routine),
    day: Number(entry.day || gameState?.day || 1),
    worldHour: Number.isFinite(Number(entry.worldHour)) ? Number(entry.worldHour) : null,
    period: entry.period || '',
    locationId: String(entry.locationId || ''),
    changes: Array.isArray(entry.changes) ? entry.changes.map((change) => ({
      label: String(change?.label || 'CHANGE'),
      delta: Number(change?.delta || 0),
      prefix: String(change?.prefix || ''),
      suffix: String(change?.suffix || ''),
    })) : [],
    source: String(entry.source || 'game'),
    createdAtEpoch: Number(entry.createdAtEpoch || 0),
  }));
}

export function adventureEntryMatches(entry, filter = 'all') {
  if (filter === 'all') return true;
  if (filter === 'important') return entry.important || ['warning', 'error', 'success', 'encounter'].includes(entry.category);
  if (filter === 'travel') return ['travel', 'adventure'].includes(entry.category);
  if (filter === 'market') return ['trade', 'market', 'economy'].includes(entry.category);
  if (filter === 'world') return ['world', 'rumor', 'sighting'].includes(entry.category);
  return true;
}

export function filteredAdventureEntries(gameState, { filter = 'all', showRoutine = true } = {}) {
  return normalizeAdventureEntries(gameState).filter((entry) => (showRoutine || !entry.routine) && adventureEntryMatches(entry, filter));
}

export function formatWorldHour(hour) {
  if (!Number.isFinite(Number(hour))) return '';
  const normalized = ((Math.trunc(Number(hour)) % 24) + 24) % 24;
  const suffix = normalized >= 12 ? 'PM' : 'AM';
  const display = normalized % 12 || 12;
  return `${display}:00 ${suffix}`;
}

export function formatAdventureChange(change) {
  const delta = Number(change?.delta || 0);
  const sign = delta > 0 ? '+' : delta < 0 ? '−' : '';
  const magnitude = Math.abs(delta);
  const value = Number.isInteger(magnitude) ? String(magnitude) : magnitude.toFixed(2).replace(/\.00$/, '');
  return `${change?.label || 'CHANGE'} ${sign}${change?.prefix || ''}${value}${change?.suffix || ''}`;
}
